<template>
    <div id="bookingBilling">


        <v-toolbar flat light color="grey lighten-4">
            <v-spacer/>
            <template v-if="model.invoiceNumber">
                <v-btn color="white" class="mr-2"
                       :href="model.invoicePdfUrl"
                       target="_blank"
                >Download Invoice <i class="fas fa-file-pdf red--text ml-2"></i></v-btn>
                <v-btn color="blue" dark class="mr-2"
                       :href="xeroInvoiceUrl(model.invoiceId)"
                       target="_blank"
                >Xero {{model.invoiceNumber}} <i class="fas fa-file-invoice ml-2"></i></v-btn>
            </template>
            <template v-else>
                <v-chip class="mr-2">Old Invoice Type</v-chip>
            </template>
            <v-btn v-if="!readonly" color="light-green" @click="save" dark>Save</v-btn>
        </v-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="4">
                    <v-card color="mb-2">
                        <v-toolbar flat >
                            <v-toolbar-title>Invoice Details</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                            <div class="Invoice Details">
                                <v-form>
                                    <v-text-field
                                            v-model="model.customerPoRef"
                                            label="Customer PO Reference"
                                            :readonly="readonly"
                                    />
                                    <DatePicker
                                            v-model="model.taxDate"
                                            label="Tax Date *"
                                            :readonly="readonly"
                                            clearable
                                    />
                                </v-form>
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-toolbar flat >
                            <v-toolbar-title>Payment</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                            <div class="Invoice Details">
                                <v-form>
                                    <DatePicker
                                            v-model="model.paidDate"
                                            label="Paid Date"
                                            clearable
                                            :readonly="readonly"
                                    />
                                    <TypeSelector
                                            v-model="model.paymentType"
                                            type="payment"
                                            label="Payment Type"
                                            :readonly="readonly"
                                    />
                                </v-form>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="4">

                    <v-card loading="invoiceContactUpdating">
                        <v-toolbar flat >
                            <v-toolbar-title>Invoice Contact</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                            <div class="BookingContactForm">
                                <v-form>
                                    <v-form-base :col="12" :model="model" :schema="schema"/>
                                </v-form>
                            </div>
                        </v-card-text>
                    </v-card>

                </v-col>
                <v-col cols="4">

                    <v-card loading="invoiceContactUpdating">
                        <v-toolbar flat >
                            <v-toolbar-title>Pricing</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                            <BookingPricingForm :model="model" :readonly="readonly"/>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>
        </v-container>
    </div>
</template>

<script>
    import BookingPricingForm from "./BookingPricingForm";
    import BOOKING_UPDATE from "../../graphql/Bookings/Update.gql";
    import VFormBase from 'vuetify-form-base';
    import DatePicker from "../DatePicker";
    import TypeSelector from "../TypeSelector";

    export default {
        name: "booking-view",
        components: {VFormBase, BookingPricingForm, DatePicker, TypeSelector},
        props: {
            model: Object,
            readonly: {
                type: Boolean,
                default:false
            },
        },
        data() {
            return {
                updating: false
            }
        },
        watch: {
            updating(val) {
                this.$emit('updating', val);
            }
        },
        computed: {
            schema() {
                return {
                    invoiceName: {type: 'text', label: 'Name', readonly: this.readonly},
                    invoiceCompany: {type: 'text', label: 'Company', readonly: this.readonly},
                    invoiceEmail: {type: 'email', label: 'Email', readonly: this.readonly},
                    invoiceAddress1: {type: 'text', label: 'Address 1', readonly: this.readonly},
                    invoiceAddress2: {type: 'text', label: 'Address 2', readonly: this.readonly},
                    invoiceAddress3: {type: 'text', label: 'Address 3', readonly: this.readonly},
                    invoiceTown: {type: 'text', label: 'Town', readonly: this.readonly},
                    invoiceCounty: {type: 'text', label: 'County', readonly: this.readonly},
                    invoicePostcode: {type: 'text', label: 'Postcode', readonly: this.readonly},
                    invoicePhone: {type: 'text', label: 'Phone', readonly: this.readonly},
                }
            }
        },
        methods: {
            save() {
                this.updating = true

                this.$apollo.mutate({
                    mutation: BOOKING_UPDATE,
                    variables: {
                        input:{
                            id: this.model.id,
                            customerPoRef: this.model.customerPoRef,
                            invoiceName: this.model.invoiceName,
                            invoiceCompany: this.model.invoiceCompany,
                            invoiceEmail: this.model.invoiceEmail,
                            invoiceAddress1: this.model.invoiceAddress1,
                            invoiceAddress2: this.model.invoiceAddress2,
                            invoiceAddress3: this.model.invoiceAddress3,
                            invoiceTown: this.model.invoiceTown,
                            invoiceCounty: this.model.invoiceCounty,
                            invoicePostcode: this.model.invoicePostcode,
                            invoicePhone: this.model.invoicePhone,
                            taxDate: this.model.taxDate,
                            days: this.model.days,
                            delegates: this.model.delegates,
                            courseRate: this.model.courseRate,
                            delegateRate: this.model.delegateRate,
                            dayRate: this.model.dayRate,
                            totalPrice: this.model.totalPrice,
                            vatAmount: this.model.vatAmount,
                            grossPrice: this.model.grossPrice,
                            paidDate: this.model.paidDate,
                            paymentType: this.model.paymentType,
                        }
                    },
                }).then(() => {
                    this.updating = false
                    this.$emit('saved');
                    this.$store.dispatch('notification/addSuccess', 'Booking Updated successful')
                }).catch(({error}) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

            xeroInvoiceUrl(invoiceId) {
                return 'https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=' + invoiceId;
            },
        },
    }

</script>